import { Component, OnInit } from '@angular/core';
import { PopoverController, NavParams, ModalController } from '@ionic/angular';
//  import { ModalService } from '../../services/modal.service';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { ApiAssetService } from '../../api-services/asset.api.service';
import { TextAsset } from 'src/app/models/assets/TextAsset';
// import { AddAssetWithinSceneModalPage } from '../../modals/add-asset-within-scene-modal/add-asset-within-scene-modal.page';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { HotSpotAsset } from 'src/app/models/assets/HotSpotAsset';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { Model3DAsset } from 'src/app/models/assets/Model3DAsset';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AddAssetWithinSceneModalPage } from 'src/app/modals/add-asset-within-scene-modal/add-asset-within-scene-modal.page';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { InvisibleAsset } from 'src/app/models/assets/InvisibleAsset';
import { ValidationService } from 'src/app/services/validation.service';
import { AssetWizardModalPage } from 'src/app/modals/asset-wizard-modal/asset-wizard-modal.page';

@Component({
  selector: 'app-add-asset-to-scene',
  templateUrl: './add-asset-to-scene.component.html',
  styleUrls: ['./add-asset-to-scene.component.scss'],
})
export class AddAssetToSceneComponent implements OnInit {

  public pop: PopoverController;
  public baseAsset: BaseAsset;
  public existingAssetsInScene: AssetInScene[] = [];
  public existingScenes: Scene[] = [];
  public questionSetAssetInScene: AssetInScene;
  public questionAssetInScene: AssetInScene;
  public isModalOpen: boolean = false;

  constructor(
    navParams: NavParams,
    public assetAPIService: ApiAssetService,
    public assetTypeService: AssetTypeService,
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
  ) {
    this.pop = navParams.get('popoverController');
    this.baseAsset = new BaseAsset();
  }

  ngOnInit() {
    document.getElementById('closeBtn').focus();
  }

  addAsset(assetType, event) {
    this.unfocusService.unfocus(event);
    this.baseAsset.assetTypeId = this.assetTypeService.getId(assetType as string) as number;
    this.baseAsset.name = '';
    this.baseAsset.description = '';
    this.baseAsset.assetManagementPageId = -1;

    switch (assetType) {
      case 'Text': {
        this.addText();
        break;
      }
      case 'Image': {
        this.addImage();
        break;
      }
      case 'Video': {
        this.addVideo();
        break;
      }
      case 'Audio': {
        this.addAudio();
        break;
      }
      case 'HotSpot': {
        this.addHotSpot();
        break;
      }
      case 'Question': {
        this.addQuestion();
        break;
      }
      case 'Model3D': {
        this.add3DModel();
        break;
      }
      case 'QuestionSet': {
        this.addQuestionSet();
        break;
      }
      case 'Invisible': {
        this.addInvisibleArea();
        break;
      }
    }
  }

  setAssetDefaultName(baseAsset: BaseAsset){
    let index: number = 1;
    let valid: boolean = false;
    let name = baseAsset.name + " " + index.toString();

    while(valid == false){
      let assetInScene = this.existingAssetsInScene.find(a => a.baseAsset.name == name);
      if(!assetInScene){
        valid = true;
      }else{
        index++;
        name = baseAsset.name + " " + index.toString();
      }
    }
    baseAsset.name = name;
  }

  addText() {
    var textA: TextAsset = this.baseAsset as TextAsset;
    textA.textColour = "#000000";
    textA.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    textA.text = '';
    textA.hasBackground = false;
    textA.backgroundColour = "#ffffff";
    textA.name = "Text Media";
    this.setAssetDefaultName(textA);
    this.openAddAssetWithinSceneModal(textA);
  }

  addImage() {
    var imageA: MediaAsset = this.baseAsset as MediaAsset;
    imageA.src = null;
    imageA.name = "Image Media";
    this.setAssetDefaultName(imageA);
    this.openAddAssetWithinSceneModal(imageA);
  }

  addVideo() {
    var videoA: MediaAsset = this.baseAsset as MediaAsset;
    videoA.src = null;
    videoA.name = "Video Media";
    this.setAssetDefaultName(videoA);
    this.openAddAssetWithinSceneModal(videoA);
  }

  addAudio() {
    var audioA: MediaAsset = this.baseAsset as MediaAsset;
    audioA.src = null;
    audioA.name = "Audio Media";
    this.setAssetDefaultName(audioA);
    this.openAddAssetWithinSceneModal(audioA);
  }

  addHotSpot() {
    var hotSpotA: HotSpotAsset = this.baseAsset as HotSpotAsset;
    hotSpotA.name = "Hotspot Media";
    this.setAssetDefaultName(hotSpotA);
    this.openAddAssetWithinSceneModal(hotSpotA);
  }

  addQuestion() {
    var questionA: QuestionAsset = this.questionAssetInScene.baseAsset as QuestionAsset;
    questionA.planeColour = '#ffffff';
    questionA.textColour = '#000000';
    questionA.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionA.backgroundOpacity = 1;
    questionA.textSize = 25;
    questionA.correctMessage = "Well Done!";
    questionA.incorrectMessage = "You got this wrong!";
    questionA.score = 1;
    questionA.hasFeedback = true;
    questionA.questionType = "Standard";
    questionA.responses = [];
    questionA.responses.push(this.getDefaultResponse(questionA, 1));
    questionA.responses.push(this.getDefaultResponse(questionA, 2));
    questionA.name = "Single Question Media";
    this.questionAssetInScene.assets = [];
    this.questionAssetInScene.events = [];
    this.questionAssetInScene.questionRules = [];
    this.setAssetDefaultName(questionA);
    this.openAddAssetWithinSceneModal(questionA);
  }

  getDefaultResponse(baseAsset: QuestionAsset, i): QuestionResponse {
    var response: QuestionResponse = new QuestionResponse();
    let maxResponseIndex = 0;
    response.text = 'Default Response ' + i;
    response.isCorrect = i == 1 ? true : false;
    response.textSize = 29;
    response.hasImage = false;
    response.imageSceneAssetRelationId = 0;
    response.hasVideo = false;
    response.videoSceneAssetRelationId = 0;
    response.hasAudio = false;
    response.audioSceneAssetRelationId = 0;
    response.hasLinkedScene = false;
    response.linkedSceneID = 0;
    response.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";

    for (let i: number = 0; i < baseAsset.responses.length; i++) {
      if (baseAsset.responses[i].questionResponseIndex > maxResponseIndex)
        maxResponseIndex = baseAsset.responses[i].questionResponseIndex;
    }

    response.questionResponseIndex = maxResponseIndex + 1;
    
    return response;
  }

  add3DModel() {
    var model3DA: Model3DAsset = this.baseAsset as Model3DAsset;
    model3DA.name = "3D Model Media";
    this.setAssetDefaultName(model3DA);
    this.openAddAssetWithinSceneModal(model3DA);
  }

  addQuestionSet() {
    var questionSetA: QuestionSetAsset = this.questionSetAssetInScene.baseAsset as QuestionSetAsset;
    questionSetA.coverPage = true;
    questionSetA.planeColour = '#ffffff';    
    questionSetA.backgroundOpacity = 1;
    questionSetA.title = "";
    questionSetA.titleSize = 25;
    questionSetA.titleColour = '#000000';
    questionSetA.questionSetDescription = "";
    questionSetA.questionSetDescriptionSize = 29;
    questionSetA.questionSetDescriptionColour = '#000000';
    questionSetA.minScoreToPass = 1;
    questionSetA.confirmationPage = true;
    questionSetA.resultsPage = true;
    questionSetA.endPageTitleSize =25;
    questionSetA.endPageTitleColour = '#000000';
    questionSetA.endPageTextSize =29;
    questionSetA.endPageTextColour = '#000000';
    questionSetA.resultsPageTitleSize =25;
    questionSetA.resultsPageTitleColour = '#000000';
    questionSetA.resultsPageTextSize =29;
    questionSetA.resultsPageTextColour = '#000000';
    questionSetA.coverPageFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.confirmationPageFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.resultsPageFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.coverPageTitleFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.confirmationPageTitleFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.resultsPageTitleFontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    questionSetA.confirmationPageTitle = "CONFIRMATION PAGE";
    questionSetA.confirmationPageAnswersCompletedText = "Are you sure you want to submit all the questions?\r\nClick on the question numbers below to review your answers.";
    questionSetA.confirmationPageAnswersNotCompletedText = "You didn't answer all the questions, are you sure you want to submit all the questions?\r\nClick on the question numbers below to review your answers.";
    questionSetA.resultsPageTitle = "RESULTS PAGE";
    questionSetA.resultsPageText = "";
    questionSetA.resultsPagePassedText = "Passed!";
    questionSetA.resultsPageFailedText = "Failed!";
    questionSetA.questionIndex = -1;
    questionSetA.name = "Quiz Media";
    this.questionSetAssetInScene.assets = [];
    this.setAssetDefaultName(questionSetA);
    this.openAddAssetWithinSceneModal(questionSetA);
  }

  addInvisibleArea() {
    var invisibleA: InvisibleAsset = this.baseAsset as InvisibleAsset;
    invisibleA.name = "Object Selection Tool Media";
    this.setAssetDefaultName(invisibleA);
    this.openAddAssetWithinSceneModal(invisibleA);
  }

  close() {
    this.pop.dismiss();
  }


  async openAddAssetWithinSceneModal(asset: BaseAsset) {

    // The modal below is determined by the asset type. Once the user enters data and closes the model,
    // the modal.onDidDismiss() handles the resulting data.
    // The asset is passed so the asset's details can be updated once the model opens.
    const modal = await this.CreateModelFromAssetType(asset, this.existingAssetsInScene, this.existingScenes);
    
    if(!modal) return;

    // this handles the data after the modal is completed.
    modal.onDidDismiss().then(result => {
      if (result.data) {        
        // popover.onDidDismiss().then(...) is found in author.service.ts
        // This handles what to do when the popover is closed.
        if(result.data.assetType == 'QuestionSet'){
          this.pop.dismiss({
            "asset": result.data.assetForScene,
            "assetType": result.data.assetType,
            "questionProperties": result.data.questionProperties
          });
        }else if(result.data.assetType == 'Question'){
          this.pop.dismiss({
            "asset": result.data.assetForScene,
            "assetType": result.data.assetType,
            "questionProperties": result.data.questionProperties
          });
        }else if(this.validationService.isMediaAsset(result.data.assetType)){
          this.pop.dismiss({
            "asset": result.data.baseAsset,
            "assetType": result.data.assetType,
            "assetSrc": result.data.baseAssetSrc,
            "aspectRatioConstant": result.data.aspectRatioConstant
          });
        }else{
          this.pop.dismiss({
            "asset": result.data.baseAsset,
            "assetType": result.data.assetType
          });
        }        
      }
      this.isModalOpen = false;
    });
    return await modal.present();
  }

  async CreateModelFromAssetType(asset: BaseAsset, existingAssetsInScene, existingScenes) {
    var assetType = this.assetTypeService.getType(asset.assetTypeId);
    var modal = null;
    var modalId = this.getModalId(assetType);

    if(this.isModalOpen === true) return null;
    this.isModalOpen = true;

    if(assetType == 'QuestionSet'){
      modal = await this.modalController.create({
        component: AssetWizardModalPage,
        id: modalId,
        componentProps: {
          "assetInScene": this.questionSetAssetInScene,
          "existingAssetsInScene": existingAssetsInScene,
          "existingScenes": existingScenes
        },
        backdropDismiss: false
      });
    }else if(assetType == 'Question'){
      modal = await this.modalController.create({
        component: AssetWizardModalPage,
        id: modalId,
        componentProps: {
          "assetInScene": this.questionAssetInScene,
          "existingAssetsInScene": existingAssetsInScene,
          "existingScenes": existingScenes
        },
        backdropDismiss: false
      });
    }else{
      modal = await this.modalController.create({
        component: AddAssetWithinSceneModalPage,
        id: modalId,
        componentProps: {
          "baseAsset": asset,
          "existingAssetsInScene": existingAssetsInScene,
          "existingScenes": existingScenes
        }
      });
    }
    
    return modal;
  }

  getModalId(assetType) {
    var modalId: string = '';
    switch (assetType) {
      case 'Text': {
        modalId = 'add-text-object-modal';
        break;
      }
      case 'Image':
      case 'Video':
      case 'Audio': {
        modalId = 'add-media-object-modal';
        break;
      }
      case 'Model3D': {
        modalId = 'add-model3D-object-modal';
        break;
      }
      case 'HotSpot': {
        modalId = 'add-hotspot-object-modal';
        break;
      }
      case 'Question': {
        modalId = 'add-question-object-modal';
        break;
      }
      case 'QuestionSet': {
        modalId = 'add-question-set-object-modal';
        break;
      }
      case 'Invisible': {
        modalId = 'add-invisible-object-modal';
        break;
      }
    }
    return modalId;
  }
}
